export default __webpack_public_path__ + "static/media/screen2.8722c28e.png";